import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { logout } from '../../utils/util-func';

export const onResponse = (res: AxiosResponse) => {
  return res;
};

let isAlertShown = false;

// 서버 에러 피드백 (모달로 안내)
let isServerErrorFeedbackShown = false;
const showServerErrorFeedback = () => {
  if (isServerErrorFeedbackShown) return;
  isServerErrorFeedbackShown = true;
  setTimeout(() => {
    isServerErrorFeedbackShown = false;
  }, 3000);

  const { store } = require('../../../store');
  const { openAlert } = require('../../../store/features/modalSlice');
  store.dispatch(
    openAlert({
      message: '서버가 일시적으로 불안정합니다.\n잠시 후 다시 시도해 주세요.',
    }),
  );
};

export const onResError = (error: AxiosError | Error) => {
  if (axios.isAxiosError(error)) {
    const config = error.config as any;
    const { method, url } = config as InternalAxiosRequestConfig;

    // retry 체인에서 이미 처리된 에러는 중복 처리하지 않음
    // (instance(config) 재시도 시 onResError가 여러 번 호출되는 것 방지)
    if (config?.__errorHandled) return Promise.reject(error);
    config.__errorHandled = true;

    // 서버 완전 다운 (Network Error, timeout 등)
    if (!error.response) {
      showServerErrorFeedback();
      return Promise.reject(error);
    }

    const { statusCode, message } = error.response.data;

    // 500번대 서버 에러
    if (statusCode >= 500) {
      showServerErrorFeedback();
      return Promise.reject(error);
    }

    const expectedUrl = [
      '/v1/auth/sign-in',
      '/v1/sms/with-name',
      '/v1/auth/user-authorization?check=true',
    ];

    // 반복 실패시 한번만 처리를 위한 코드
    if (isAlertShown) return;
    isAlertShown = true;
    setTimeout(() => {
      isAlertShown = false;
    }, 1000);

    if (expectedUrl.includes(url)) return Promise.reject(error);

    switch (statusCode) {
      case 401:
        alert('로그인이 필요합니다.');
        logout();
        if (!localStorage.getItem('redirect')) {
          if (window.location.href.split('/').pop() !== 'signin')
            localStorage.setItem('redirect', window.location.href);
        }
        window.location.href = '/signin';
        return error.response;

      case 403:
        alert('접근 권한이 없습니다.');
        window.location.href = '/';
        return error.response;

      default:
        return Promise.reject(error);
    }
  } else {
    console.log(`🚨 [API] | Error ${error.message}`);
  }

  return Promise.reject(error);
};
